import { useProjectStore } from 'features/project/store'
import { ProjectState } from 'types/project'

export function useCatalogDetailProjectId(): string {
  return useProjectStore((state: ProjectState) => state.projectId)
}
